<template>
    <div id="attribute-form">
        <div class="form-group">
            <text-field v-if="type==='text'"/>
            <color-field v-if="type==='text'"/>
            <video-field v-if="type==='video'"/>
            <image-field v-if="type==='image'"/>
            <dynamic-field v-if="selected.id"/>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
	import VideoColorField from 'components/field/VideoColorField'
	import VideoTextField from 'components/field/VideoTextField'
	import VideoDynamicField from 'components/field/VideoDynamicField'
	import VideoField from 'components/field/VideoField'
	import VideoImageField from 'components/field/VideoImageField'

	export default {
		components: {
			'video-field': VideoField,
			'text-field': VideoTextField,
			'color-field': VideoColorField,
            'dynamic-field': VideoDynamicField,
            'image-field': VideoImageField
		},
		computed: {
			type() {
				return this.$store.state.selected.type
			},
			selected() {
				return this.$store.state.selected
			}
		}
	}
</script>
